import { Col, Container, Row } from 'react-bootstrap'
import Search from '../Utilities/Search'
import { useEffect, useState } from 'react'
import { SalariesConfirmationVM } from '../../Structure/ViewModels/Marketer/SalarysConfirmation'
import { GeneralMethods } from '../../Structure/Handlers/GeneralMethods'
import { Router } from '../../Structure/Handlers/Router'
import MarketerDetails from '../Marketer/MarketerDetails'
import { Globals } from '../../Structure/Globals/GlobalObs'

const ConfirmSalaries = () => {
    const [vm , setVm] = useState<{viewModel: SalariesConfirmationVM}>({viewModel: new SalariesConfirmationVM()})
    const control = vm.viewModel
    useEffect(()=>{ control.subscribeUpdate(setVm); control.getData() },[])

  return (
    <Container>
    <Row className=' justify-content-center py-5'>
      <Col lg={8} className='d-flex'>
        <div className='d-flex w-100 justify-content-center'>
          <Search hasNoSelect/>
        </div>
      </Col>
    </Row>
    {
        control.Show(
    <div className='py-5'>
        {
            control.List.map((item,index)=>{
                const Result = (props:{item:{marketer_id:string , name: string , total_sales:string}})=>{
                    const [target ,setTarget] = useState('0')
                    const [bouns ,setBouns] = useState('0')
                    const [cuts ,setCuts] = useState('0')
                    const [total, setTotal] = useState(Number(props.item.total_sales))
                    const [avail , setAvail] = useState(true)

                    useEffect(()=>setTotal(Number(props.item.total_sales)+(Number(target)?Number(target):0)+ (Number(bouns)?Number(bouns):0)-(Number(cuts)?Number(cuts):0)),[target,bouns,cuts])

                    return(
                        <div className='p-3' style={{display:avail?'block':'none'}}>
                        <Row className='d-flex flex-wrap justify-content-around p-3  box-shadow-I'>
                            <Col md='2' className='py-2 my-auto' onClick={()=>{
                                    if(Globals.auth.User?.permissions.some(a=>a.id=='7'))Router.OpenNormalPage(<MarketerDetails id={item.marketer_id}/>)
                                }}>
                                <h5  className='my-auto py-2'>{props.item.name}</h5>
                            </Col>
                            <Col md='2' className='py-2 my-auto'>
                                <div className='d-flex'>
                                     <h5 className='my-auto'>تارجت</h5>
                                    <div className='px-3 my-auto'>
                                        <input type="text" className='input-field' value={target} onChange={a=>setTarget(GeneralMethods.removeNonFloatNumeric(a.target.value))} style={{width:'70px'}} />
                                    </div>
                                </div>
                            </Col>
                            <Col md='2' className='py-2 my-auto'>
                                <div className='d-flex'>
                                     <h5 className='my-auto'>بونص</h5>
                                    <div className='px-3 my-auto'>
                                        <input type="text" className='input-field' value={bouns} onChange={a=>setBouns(GeneralMethods.removeNonFloatNumeric(a.target.value))}  style={{width:'70px'}} />
                                    </div>
                                </div>
                            </Col>
                            <Col  md='2' className='py-2 my-auto'>
                                <div className='d-flex'>
                                     <h5 className='my-auto'>خصم</h5>
                                    <div className='px-3 my-auto'>
                                        <input type="text" className='input-field' value={cuts} onChange={a=>setCuts(GeneralMethods.removeNonFloatNumeric(a.target.value))}  style={{width:'70px'}} />
                                    </div>
                                </div>
                            </Col>
                            <Col  md='2' className='py-2 my-auto'>
                                <div className='d-flex text-success'>
                                    <h5 className='px-3 my-auto'>
                                        {total}
                                    </h5>
                                </div>
                            </Col>
                            <Col  md='2' className='py-2 my-auto'>
                                <div className='d-flex'>
                                    <div className='px-3 my-auto'>
                                        <button className='button-I btn-cl-I p-1 px-4 my-auto'  onClick={()=>{ control.confirm({id:props.item.marketer_id , target:target , cut:cuts , bounus:bouns , notes:''}); setAvail(false) }}>اعتماد</button>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                    )
                }

                return (<Result key={index} item={item}/>)

            }

            )
        }

       

    </div>)
    }
  </Container>
  )
}

export default ConfirmSalaries
